import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { FormattedDate, FormattedNumber } from 'react-intl';
import { Flex } from 'ui';
import { withEllipsis } from 'ui/styles';
import { transformSAPId } from 'utils/helpers';

const CellLabel = styled.label`
  color: #999;
  word-break: break-word;
  font-size: 12px;
`;

const CellText = styled.label`
  margin-top: -4px;
  font-weight: 400;
  min-height: 1.48em;
  max-width: 100%;
  word-break: break-word;
  font-size: ${p => p.theme.fontSize.large} !important;
  width: ${p => p.width};
  ${withEllipsis};
`;

const formatValue = (value, format, unit) =>
({
  number: <span>
    {value && <FormattedNumber value={value} />} {unit}
  </span>,
  currency: <span>
    {/* eslint-disable-next-line */}
    {value && <FormattedNumber value={value} style='currency' currency={unit || 'EUR'} />}
  </span>,
  date: <span>{value && value !== '0001-01-01T00:00:00' && <FormattedDate value={value} />}</span>,
  sapId: <span>{value && transformSAPId({ originalId: value })}</span>,
  // eslint-disable-next-line max-len
  materialNumber: <span>{value && transformSAPId({ originalId: value, isMaterialNumber: true })}</span>
  ,
}[format] || value);

// eslint-disable-next-line
class TableCell extends PureComponent {
  render() {
    const {
      visibleFn,
      unitField,
      unit,
      label,
      renderLabelFn,
      width,
      renderValueFn,
      format,
      value,
      record,
      index,
    } = this.props;
    if ((visibleFn && visibleFn(value, record)) || !visibleFn) {
      const unitToUse = unitField ? record[unitField] : unit;
      return (
        <Flex data-test-id='table-cell' fdc jcsa>
          {(label || renderLabelFn) &&
            <CellLabel data-test-id='cell-label'>
              {renderLabelFn ? renderLabelFn(value, record, index) : label}
            </CellLabel>
          }
          <CellText data-test-id='cell-text' width={width}>
            {renderValueFn
              ? renderValueFn(value, record, index)
              : formatValue(value, format, unitToUse)}
          </CellText>
        </Flex>
      );
    }
    return null;
  }
}

TableCell.propTypes = {
  visibleFn: PropTypes.func,
  unitField: PropTypes.string,
  unit: PropTypes.string,
  label: PropTypes.string,
  renderLabelFn: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderValueFn: PropTypes.func,
  format: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  record: PropTypes.object,
  index: PropTypes.number,
};

export default TableCell;
